import { Button } from "antd";
import { useCallback, useState } from "react";

import { RequestAccessModal } from "./RequestAccessModal";

export const RequestAccessModalButton: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleShowCreateRequestModal = useCallback(() => {
    setIsModalOpen(true);
  }, []);

  const handleRequestAccessModalCancel = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  return (
    <>
      <Button
        type="primary"
        variant="filled"
        onClick={handleShowCreateRequestModal}
      >
        Request Access
      </Button>
      {isModalOpen && (
        <RequestAccessModal
          open={isModalOpen}
          onCancel={handleRequestAccessModalCancel}
        />
      )}
    </>
  );
};
